/**
 * @author Sudarshan Shakya (sam@thespaceinbetween.co.nz)
 *
 * this module handles the vacancies section on the careers page.
 * this will send an AJAX request and try to fetch the content
 * of the given URL.
 *
 * @type {{bindEvents: Careers.bindEvents, init: Careers.init}}
 */
const Careers = {

    /**
     * this will be binding all required JS and events
     * for the vacancies to run.
     * @param $wrapper
     */
    bindEvents: ($wrapper) => {

        Careers.data = {
            $button: $('#vacancies__button'),
            $close: $('#vacancies__close'),
            $list: $('#vacancies__list'),
            $mask: $('#vacancies__mask'),
            $wrapper: $wrapper,
        };

        $.ajax({
            type: 'GET',
            url: '/vacancies',
            success: function(data) {
                Careers.extract(data);
            },
            error: function(message) {
                console.log('Error ', message);
                Careers.data.$list.html('<h4>Sorry!</h4>We are currently having issues to get vacancies. Please try again later.');
            }
        });

        // remove active class when closing overlay
        Careers.data.$close.click((e) => {
            e.preventDefault();
            $('#vacancies__wrapper').removeClass('active');
        });

        // check if footer is visible (to hide mobile buttons for careers overlay)
        let $footer = $('.sib-footer__wrapper');
        if ($footer.length > 0) Careers.checkFooter($footer);

        // re-calculate VH on window resize.
        $(window).resize(() => {
            Careers.fixVH();
        });
        Careers.fixVH(); // fix Ios VH
    },

    /**
     * this function will extract the resultant html and
     * create required markup for the view.
     *
     * @param data
     */
    extract: (data) => {
        console.log('hello')
        Careers.data.$mask.html(data);
        // clear unnecessary data
        Careers.data.$mask.find('.short-desc, .indicators, .post-date, .loc, .close-date').remove();
        // get all jobs
        let html = '',
            loaded = 0;

        Careers.data.$mask.find('.job-item').each((e, elm) => {
            let $elm = $(elm);

            let expertise = $elm.find('.expertise').text(),
                link = $elm.find('.clicker-link').attr('href'),
                title = $elm.find('.clicker-link span').text(),
                type = $elm.find('.work-type').text();

            if (loaded++ >= 5) {
                return;
            }
            html = `${html}<a href="https://skycitycareers.com${link}" target="_blank"><span class="job-title">${title}</span><span class="job-expertise">${expertise}</span><span class="job-type">${type}</span></a>`;
        });
        Careers.data.$list.html(html).addClass('show-more');
        Careers.data.$mask.html('');
    },

    /**
     * this function will check if the given element is visible in DOM
     *
     * @param $elm
     */
    checkFooter: ($elm) => {
        // Bind event on scroll
        $(window).scroll(() => {
            if (Careers.isInViewport($elm)) Careers.data.$button.removeClass('active');
            else Careers.data.$button.addClass('active');
        });

        if (Careers.isInViewport($elm)) Careers.data.$button.removeClass('active');
        else Careers.data.$button.addClass('active');
    },

    /**
     * this function will be called on each page resize
     * and will calculate the new width of the frame1 logo and title
     */
    fixVH: () => {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    /**
     * this function will check if the element is visible
     * in the DOM or not.
     *
     * @param $elm
     * @returns {boolean}
     */
    isInViewport: ($elm) => {
        let elementTop = $elm.offset().top,
            elementBottom = elementTop + $elm.outerHeight(),
            viewportTop = $(window).scrollTop(),
            viewportBottom = viewportTop + $(window).height();

        // offset element Top and Bottom for ios height fix
        if ($(window).width() < 768) {
            elementTop = elementTop - 200;
            elementBottom = elementBottom + 400;
        }

        // console.log(viewportTop, viewportBottom, elementTop, elementBottom);
        return elementBottom > viewportTop && elementTop < viewportBottom;
    },

    /**
     * initialize the module if the DOM contains
     * required vacancies wrapper.
     */
    init: () => {
        let $vacancies = $('#vacancies');

        if ($vacancies.length === 1)
            Careers.bindEvents($vacancies);
    },
};

module.exports = Careers;



// WEBPACK FOOTER //
// ./src/js/partials/careers.js